export default __webpack_public_path__ + "static/media/MineFI.24e4fd5d.jpg";